import {
  TaskInterface,
  CreateTaskInterface,
  UpdateTaskInterface,
  ListTaskQueryInterface,
  TaskListDataInterface,
  TotalHoursDataInterface,
  ChartDataInterface,
} from "@/types/task";
import { get, del, post, put } from "@/utils/taskApiClient.utils";

export const getRunningTask = () => {
  return get<TaskInterface>("task");
};

export const retrieveTask = (taskId: number | string) => {
  return get<TaskInterface>(`task/${taskId}`);
};

export const listTasks = (query: ListTaskQueryInterface) => {
  return get<TaskListDataInterface>("tasks", { ...query });
};

export const deleteTask = (taskId: number | string) => {
  return del<TaskInterface>(`task/${taskId}`);
};

export const createTask = (createTaskDto: CreateTaskInterface) => {
  return post<TaskInterface>("task", createTaskDto);
};

export const updateTask = (
  taskId: number | string,
  updateTaskDto: UpdateTaskInterface,
) => {
  return put<TaskInterface>(`task/${taskId}`, updateTaskDto);
};

export const getTotalHours = (
  query: Omit<ListTaskQueryInterface, "limit" | "offset">,
) => {
  return get<TotalHoursDataInterface[]>("total-hours", { ...query });
};

export const getChartData = (
  query: Omit<ListTaskQueryInterface, "limit" | "offset">,
) => {
  return get<ChartDataInterface[]>("chart", { ...query });
};
